import * as t from '../actionTypes'
import axios from 'utils/axios'
import { guardFromErrors, extractErrorInfo } from 'utils/graphqlHelpers'
import { PostmarkSetting } from '../types'

type PostmarkSettingInput = {
  name: string
  apiKey: string
  from: string
}

export type CreatePostmarkSettingAction = FSA<undefined, PostmarkSetting, string>
type CreatePostmarkSetting = (postmarkSettingData: PostmarkSettingInput) => MrxThunk<CreatePostmarkSettingAction, Promise<boolean>>
type QueryResponse = GraphQLResponse<'createPostmarkSetting', PostmarkSetting>

const CREATE_POSTMARK_SETTING = `
  mutation createPostmarkSetting ($workspaceId: Int!, $postmarkSettingData: PostmarkSettingInput!) {
    createPostmarkSetting (workspaceId: $workspaceId, postmarkSettingData: $postmarkSettingData) {
      id
      name
      apiKey
      from
    }
  }
`

const createPostmarkSetting: CreatePostmarkSetting = (postmarkSettingData) => async (dispatch, getState) => {
  let isSaved = false

  dispatch({
    type: t.CREATE_POSTMARK_SETTING,
    meta: { done: false }
  })

  try {
    const workspaceId = getState()?.workspaces?.activeWorkspace?.id
    const {
      data: { data, errors }
    }: QueryResponse = await axios.post('/graphql', {
      query: CREATE_POSTMARK_SETTING,
      variables: { workspaceId, postmarkSettingData }
    })

    guardFromErrors(errors)

    if (!data) {
      throw new Error('Response body is empty!')
    }

    const { createPostmarkSetting } = data
    if (!createPostmarkSetting) {
      throw new Error("Can't create Postmark Setting!")
    }

    dispatch({
      type: t.CREATE_POSTMARK_SETTING,
      payload: createPostmarkSetting,
      meta: { done: true }
    })
    isSaved = true
  } catch (err) {
    dispatch({
      type: t.CREATE_POSTMARK_SETTING,
      payload: extractErrorInfo(err) as string,
      error: true
    })
  }

  return isSaved
}

export { createPostmarkSetting }
